import { render, staticRenderFns } from "./WaitingHandle.vue?vue&type=template&id=25c94b22&scoped=true&"
import script from "./WaitingHandle.vue?vue&type=script&lang=js&"
export * from "./WaitingHandle.vue?vue&type=script&lang=js&"
import style0 from "./WaitingHandle.vue?vue&type=style&index=0&id=25c94b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c94b22",
  null
  
)

export default component.exports